/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BillDetailsDto as DigiworkMaitreDPosDtoBillsBillDetailsDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Bills/bill-details-dto';

export interface GetBill$Params {
  billId: string;
}

export function getBill(http: HttpClient, rootUrl: string, params: GetBill$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoBillsBillDetailsDto>> {
  const rb = new RequestBuilder(rootUrl, getBill.PATH, 'get');
  if (params) {
    rb.path('billId', params.billId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoBillsBillDetailsDto>;
    })
  );
}

getBill.PATH = '/api/orders/bills/{billId}/details';
